import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=673c39da&scoped=true&"
import script from "./Close.vue?vue&type=script&lang=js&"
export * from "./Close.vue?vue&type=script&lang=js&"
import style0 from "./Close.vue?vue&type=style&index=0&id=673c39da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c39da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673c39da')) {
      api.createRecord('673c39da', component.options)
    } else {
      api.reload('673c39da', component.options)
    }
    module.hot.accept("./Close.vue?vue&type=template&id=673c39da&scoped=true&", function () {
      api.rerender('673c39da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Close.vue"
export default component.exports